<div class="day-col" [style.background]="day.color" [style.marginRight]="day.marginRight"></div>
